var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-loader",
    x: "0px",
    y: "0px",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "spinner",
    fill: "#Fe5c00",
    d: "M40,72C22.4,72,8,57.6,8,40C8,22.4,   22.4,8,40,8c17.6,0,32,14.4,32,32c0,1.1-0.9,2-2,2   s-2-0.9-2-2c0-15.4-12.6-28-28-28S12,24.6,12,40s12.6,   28,28,28c1.1,0,2,0.9,2,2S41.1,72,40,72z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.22b7df0d9a3cd4fa8e5cfc1111da3636.svg";
export { ForwardRef as ReactComponent };